import { GET_ACCOUNT_SUCCESS } from '../constants/Api'
import { SET_PROFILE_DATA } from '../constants/Misc'
import normalize from 'json-api-normalizer'
import { createSelector } from 'reselect'
import build from 'redux-object'
import keys from 'lodash/keys'
import get from 'lodash/get'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_ACCOUNT_SUCCESS:
    case SET_PROFILE_DATA:
      return normalize(action.payload)

    default:
      return state
  }
}

const getProfileDataSelector = state => state.profile

export const profileIDSelector = createSelector([getProfileDataSelector], data => {
  return !!data && keys(data.accounts || {})[0]
})

export const profileSelector = createSelector([getProfileDataSelector], data => {
  const id = keys(data.accounts)[0]
  return build(data, 'accounts', id, { ignoreLinks: true, eager: true })
})

const BLANK_OBJECT = {}
// Тут с бекенда приходит цена за триальный период (1 рубль сейчас), если у человека есть право на триал.
export const activeWebTrialOfferPricesSelector = createSelector([profileSelector], profile => {
  return get(profile, 'activeWebTrialOfferPrices') || BLANK_OBJECT
})
